// extracted by mini-css-extract-plugin
module.exports = {"mobileLanguageSelector":"MobileLanguageSelect_mobileLanguageSelector__1wzn_"};